import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { DatabaseApiServiceService } from '../../../database-api-service.service';
import Swal from 'sweetalert2'
import { Constants } from "src/app/constants";
import { Router } from '@angular/router';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
})
export class LoginComponent implements OnInit {

  myUserForm: FormGroup

  lockForm: Boolean;
  
  constructor(private fb: FormBuilder, private databaseService: DatabaseApiServiceService, private router: Router) {}

  ngOnInit(): void {
    this.lockForm = false;
    this.myUserForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  forgotPassword(){
    Swal.fire({
      title: "Password Rest",
      text: "Please contact your system administrator for assistance in resetting your password",
      icon: 'info',
      confirmButtonText: 'Okay'
    })
  }

  logInUser(){
    console.log("Logging in user");
    this.lockForm = true;
    console.log(this.myUserForm);
    if(this.myUserForm.value.username === ''){
      Swal.fire({
        title: 'Error!',
        text: 'Please fill out username field to log in.',
        icon: 'error',
        confirmButtonText: 'Cool'
      })
      this.lockForm = false;
      return;
    }

    Swal.fire({
      title: 'Log In.',
      text: 'One moment while we log you into your document portal.',
      timerProgressBar: true,
    }).then((result) => {
      /* Read more about handling dismissals below */
      if (result.dismiss === Swal.DismissReason.timer) {
        console.log('I was closed by the timer')
      }
    });

    this.databaseService.login(this.myUserForm.value.username, this.myUserForm.value.password).subscribe((result) => {
      Swal.close();
      this.lockForm = false;
      console.log(this.lockForm);
      console.log(result);
      if(result.status== Constants.SUCCESS_CODE){
        Swal.fire({
          position: 'top-end',
          title: 'Success',
          text: Constants.LOGGED_IN_SUCCESS_MESSAGE,
          icon: 'success',
          showConfirmButton: false,
          timer: 1500
        })
        this.router.navigate(['admin/tables'])
      }
      else{
        this.lockForm = false;
        console.log(this.lockForm);
        this.myUserForm.value.password = '';
        Swal.fire({
          title: 'Error!',
          text: result.message,
          icon: 'error',
          confirmButtonText: 'Okay'
        })
        return;
      }
    })
  }
}
